import { useState } from "react";
import { color, MiscUtils } from "@my/util";
import { XStack, YStack, Card, H2, Paragraph } from "tamagui";
import { ChevronDown, ChevronUp } from "@tamagui/lucide-icons-2";
import { defaultTo } from "lodash";
import { ActionButton } from "../UtilComponents/index.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
const TZACardStyle = {
  //backgroundImage: 'linear-gradient(to right, rgb(250, 250, 250), rgb(242, 242, 242))',
  backgroundImage: "linear-gradient(to right, rgb(255, 255, 255), rgb(255, 255, 255))",
  borderColor: "rgba(108, 117, 125, 0.44)",
  borderRadius: 9,
  height: "fit-content"
};
const TZACard = ({
  title,
  value,
  subTitle,
  style,
  ...rest
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const backgroundImage = defaultTo(rest.backgroundImage, TZACardStyle.backgroundImage);
  const borderColor = defaultTo(rest.borderColor, TZACardStyle.borderColor);
  const dynamicHeight = true ? isExpanded ? {
    alignSelf: "stretch"
  } : {
    height: TZACardStyle.height
  } : {};
  const cursorStyle = rest.expandable ? {
    cursor: "pointer"
  } : {};
  const rootCardStyle = {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor,
    maxWidth: 300,
    minHeight: 105,
    width: "100%",
    ...cursorStyle,
    ...dynamicHeight,
    ...(style || {})
  };
  const triggerColor = rest.expanderDetails?.triggerColor || color.tzaGreen;
  const icon = rest.expandable ? /* @__PURE__ */jsx(ActionButton, {
    unstyled: true,
    disabled: true,
    color: color.grey,
    borderRadius: 3,
    backgroundColor: triggerColor,
    icon: isExpanded ? ChevronUp : ChevronDown,
    style: {
      height: 18,
      width: 18,
      alignItems: "center",
      justifyContent: "center"
    }
  }) : rest.icon;
  const children = rest.expandable && rest.expanderDetails ? isExpanded ? rest.expanderDetails.content : null : rest.children;
  const expandableRootProps = rest.expandable ? {
    onPress: () => setIsExpanded(prev => !prev),
    hoverStyle: {
      backgroundColor: "#e7e7e7",
      backgroundImage: "none"
    },
    ...MiscUtils.ui.shadowGenerator(0.2)
  } : {};
  return /* @__PURE__ */jsxs(Card, {
    elevate: true,
    size: "$4",
    bordered: true,
    borderRadius: TZACardStyle.borderRadius,
    style: rootCardStyle,
    ...rest,
    ...expandableRootProps,
    children: [rest.omitHeader ? null : /* @__PURE__ */jsx(Card.Header, {
      children: /* @__PURE__ */jsxs(XStack, {
        children: [/* @__PURE__ */jsxs(YStack, {
          children: [/* @__PURE__ */jsx(Paragraph, {
            children: title
          }), /* @__PURE__ */jsx(H2, {
            children: value
          }), subTitle ? /* @__PURE__ */jsx(Paragraph, {
            theme: "alt2",
            children: subTitle
          }) : null]
        }), icon ? /* @__PURE__ */jsx(XStack, {
          style: {
            marginLeft: "auto",
            borderRadius: 9999,
            backgroundColor: "transparent",
            height: 32,
            /* width: 32, */
            justifyContent: "center",
            alignItems: "center"
          },
          children: icon
        }) : null]
      })
    }), children ? children : null, /* @__PURE__ */jsx(Card.Background, {
      borderRadius: 9,
      backgroundImage,
      zIndex: 0
    })]
  });
};
const TZASummaryCardsContainer = ({
  children
}) => {
  return /* @__PURE__ */jsx(XStack, {
    gap: 10,
    flexWrap: "wrap",
    justifyContent: "center",
    style: {
      height: "fit-content"
    },
    children
  });
};
const TZASummaryCards = ({
  cards
}) => {
  return /* @__PURE__ */jsx(TZASummaryCardsContainer, {
    children: cards.map((card, key) => /* @__PURE__ */createElement(TZACard, {
      ...card,
      key
    }))
  });
};
export { TZACard, TZACardStyle, TZASummaryCards, TZASummaryCardsContainer };
//# sourceMappingURL=cards.mjs.map
